import React from 'react';

const isModuleEnabled = (name) => ({});
const configurations = {};

// eslint-disable-next-line import/prefer-default-export
export const ConfigurationsContext = React.createContext({ configurations, isModuleEnabled });
